import React from 'react';
import { getContext } from 'common';

import Styled from './styles';

export interface CalendarContentProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the Calender, consider using `<CalendarYearPicker/>`, `<CalendarErrorMessage/>`, `<CalendarTimePicker/>` , `<CalendarMonthPicker/>` and `<CalendarDayPicker/>`. `<CalendarContent/>` is mandatory to use if <CalendarYearPicker/> is configured. */
  children: React.ReactNode;
}

/**
 * `CalendarContent` is mandatory to use if <CalendarYearPicker/> is configured. All props will be provided to the root DOM element.
 * To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference.
 */
const CalendarContent = React.forwardRef<HTMLElement, CalendarContentProps>((props: CalendarContentProps, ref) => getContext(({ RTL }) => {
  const {
    children,
    ...otherProps
  } = props;
  return (
    <Styled.CalendarContent
      $rtl={RTL}
      ref={ref}
      {...otherProps}
    >
      {children}
    </Styled.CalendarContent>
  );
}));

CalendarContent.displayName = 'CalendarContent';

export default CalendarContent;
